import i18n from '@/langs/i18n.js';

export default {
  0: {
    full: i18n.t('monthsName.january'),
    short: i18n.t('monthsName.januaryShort')
  },
  1: {
    full: i18n.t('monthsName.february'),
    short: i18n.t('monthsName.februaryShort')
  },
  2: {
    full: i18n.t('monthsName.march'),
    short: i18n.t('monthsName.marchShort')
  },
  3: {
    full: i18n.t('monthsName.april'),
    short: i18n.t('monthsName.aprilShort')
  },
  4: {
    full: i18n.t('monthsName.may'),
    short: i18n.t('monthsName.mayShort')
  },
  5: {
    full: i18n.t('monthsName.june'),
    short: i18n.t('monthsName.juneShort')
  },
  6: {
    full: i18n.t('monthsName.july'),
    short: i18n.t('monthsName.julyShort')
  },
  7: {
    full: i18n.t('monthsName.august'),
    short: i18n.t('monthsName.augustShort')
  },
  8: {
    full: i18n.t('monthsName.september'),
    short: i18n.t('monthsName.septemberShort')
  },
  9: {
    full: i18n.t('monthsName.october'),
    short: i18n.t('monthsName.octoberShort')
  },
  10: {
    full: i18n.t('monthsName.november'),
    short: i18n.t('monthsName.novemberShort')
  },
  11: {
    full: i18n.t('monthsName.december'),
    short: i18n.t('monthsName.decemberShort')
  }
};
